import React from "react";
import { IActivity } from "./activity-selector.props";
import LabeledSelect from "../labeledselect/labeledselect";

interface IActivitySelectorProps {
  activities: IActivity[];
  selectedActivity: IActivity;
  handleActivitySelect: (arg?: IActivity) => void;
}

const ActivitySelector = (props: IActivitySelectorProps) => {
  const handleActivitySelect = (selectedId: number | null) => {
    const activity = props.activities.find((item) => item.pathId == selectedId);
    if (activity) {
      props.handleActivitySelect(activity);
    }
  };

  const activityValues = props.activities.map((item: IActivity) => {
    return {
      id: item.pathId,
      name: item.title
    };
  });

  return (
    <LabeledSelect
      testid="dropdown-link-player-activity-select"
      style={{ width: "225.3px", margin: "unset" }}
      options={activityValues}
      label="Activity"
      selected={props.selectedActivity?.pathId || activityValues[0].id}
      onOptionSelected={(selectedId) => {
        handleActivitySelect(selectedId);
      }}
    />
  );
};
export default ActivitySelector;
